import React from 'react';
import PropTypes from 'prop-types';

import MultiSelectOption from './multi_select_option';
import SelectOption from './select_option';
import SimpleOption from './simple_option';

export default function Option({ ...props }) {
  let OptionComponent;
  switch (props.option.type) {
  case 'simple':
    OptionComponent = SimpleOption;
    break;
  case 'multi-select':
    OptionComponent = MultiSelectOption;
    break;
  case 'single-select':
    OptionComponent = SelectOption;
    break;
  default:
    return null;
  }

  return <OptionComponent {...props} />;
}

Option.propTypes = {
  option: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
};
